import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const LOGO = "https://customer-assets.emergentagent.com/job_9b5e32bd-6e03-4600-841f-a63162f850e8/artifacts/w487gkes_lexorbit-logo.png.png";

export default function Header({ onTrialClick, onLoginClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const nav = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Sistema', href: '#sistema' },
    { label: 'Seguridad', href: '#seguridad' },
    { label: 'Planes', href: '#planes' },
    { label: 'Demo', href: '#demo' },
    { label: 'Contacto', href: '#contacto' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#080808]/95 backdrop-blur-xl border-b border-[rgba(201,164,76,0.12)]' : 'bg-[#050505]/40 backdrop-blur-sm'}`} data-testid="header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between">
        <a href="#inicio" className="flex items-center" data-testid="header-logo">
          <img src={LOGO} alt="LexOrbit" className="h-11" />
        </a>
        <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
          {nav.map(n => (
            <a key={n.href} href={n.href} className="text-[#B8B8B8] hover:text-[#C9A44C] text-[13px] tracking-wide transition-colors duration-300 font-medium">{n.label}</a>
          ))}
          <button onClick={onLoginClick} className="text-[#B8B8B8] hover:text-[#F8F6F0] text-[13px] tracking-wide transition-colors font-medium ml-1" data-testid="header-login-btn">Acceder al sistema</button>
          <button onClick={onTrialClick} className="text-[#B8B8B8]/40 text-[13px] font-semibold px-4 py-2 rounded transition-all" style={{ background: 'linear-gradient(135deg, #C9A44C, #E0C878)', color: '#050505' }} data-testid="header-trial-btn">Probar gratis 5 días</button>
        </nav>
        <button className="lg:hidden text-[#F8F6F0]" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {mobileOpen && (
        <div className="lg:hidden bg-[#080808]/98 backdrop-blur-xl border-t border-[rgba(201,164,76,0.1)] px-6 py-5 space-y-3" data-testid="mobile-nav">
          {nav.map(n => (
            <a key={n.href} href={n.href} className="block text-[#B8B8B8] hover:text-[#C9A44C] text-sm py-1" onClick={() => setMobileOpen(false)}>{n.label}</a>
          ))}
          <button onClick={() => { onLoginClick(); setMobileOpen(false); }} className="block w-full text-left text-[#B8B8B8] hover:text-[#F8F6F0] text-sm py-1">Acceder al sistema</button>
          <button onClick={() => { onTrialClick(); setMobileOpen(false); }} className="block w-full text-left text-sm py-1 font-semibold" style={{ color: '#C9A44C' }} data-testid="mobile-trial-btn">Probar gratis 5 días</button>
        </div>
      )}
    </header>
  );
}
